import { render, staticRenderFns } from "./RollCallTeacher.vue?vue&type=template&id=4223be31&scoped=true"
import script from "./RollCallTeacher.vue?vue&type=script&lang=js"
export * from "./RollCallTeacher.vue?vue&type=script&lang=js"
import style0 from "./RollCallTeacher.vue?vue&type=style&index=0&id=4223be31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223be31",
  null
  
)

export default component.exports